import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  private readonly ACCESS_TOKEN_KEY = 'accessToken';
  private readonly ID_TOKEN_KEY = 'idToken';
  private readonly REFRESH_TOKEN_KEY = 'refreshToken';

  constructor() {}

  setTokens(tokens: {
    accessToken: string,
    idToken: string,
    refreshToken: string,
    expiresIn?: number
  }): void {
    
    localStorage.setItem(this.ACCESS_TOKEN_KEY, tokens.accessToken);
    localStorage.setItem(this.ID_TOKEN_KEY, tokens.idToken);
    localStorage.setItem(this.REFRESH_TOKEN_KEY, tokens.refreshToken);
    
    if (tokens.expiresIn) {
      const expiresAt = new Date();
      expiresAt.setSeconds(expiresAt.getSeconds() + tokens.expiresIn);
      localStorage.setItem('expires_at', JSON.stringify(expiresAt.getTime()));
    }
  }

  updateTokens(tokens: {
    accessToken: string,
    idToken: string,
    expiresIn?: number
  }): void {
    
    localStorage.setItem(this.ACCESS_TOKEN_KEY, tokens.accessToken);
    localStorage.setItem(this.ID_TOKEN_KEY, tokens.idToken);
    
    if (tokens.expiresIn) {
      const expiresAt = new Date();
      expiresAt.setSeconds(expiresAt.getSeconds() + tokens.expiresIn);
      localStorage.setItem('expires_at', JSON.stringify(expiresAt.getTime()));
    }
  }

  clearTokens(): void {
    localStorage.removeItem(this.ACCESS_TOKEN_KEY);
    localStorage.removeItem(this.ID_TOKEN_KEY);
    localStorage.removeItem(this.REFRESH_TOKEN_KEY);
    localStorage.removeItem('expires_at');
  }

  getAccessToken(): string | null {
    const token = localStorage.getItem(this.ACCESS_TOKEN_KEY);
    
    if (token) {
      return token.trim();
    } else {
      console.log('[TOKEN-STORAGE] No access token found in localStorage');
    }
    
    return token;
  }

  getIdToken(): string | null {
    return localStorage.getItem(this.ID_TOKEN_KEY);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(this.REFRESH_TOKEN_KEY);
  }

  isAccessTokenExpired(): boolean {
    const expiresAt = localStorage.getItem('expires_at');
    if (!expiresAt) return true;
    
    try {
      const expirationTime = JSON.parse(expiresAt);
      const now = new Date().getTime();
      const isExpired = now >= expirationTime;
      
      if (isExpired) {
        console.log('🕒 Token expirado:', {
          now: new Date(now).toISOString(),
          expires: new Date(expirationTime).toISOString()
        });
      }
      
      return isExpired;
    } catch (error) {
      console.error('Error parsing expiration time:', error);
      return true;
    }
  }

  getTokenExpiration(): Date | null {
    const expiresAt = localStorage.getItem('expires_at');
    return expiresAt ? new Date(parseInt(expiresAt)) : null;
  }

  shouldRefreshToken(): boolean {
    const expiresAt = this.getTokenExpiration();
    if (!expiresAt) return false;
    
    const now = new Date();
    const timeUntilExpiry = expiresAt.getTime() - now.getTime();
    const fiveMinutes = 5 * 60 * 1000; // 5 minutos en ms
    
    const shouldRefresh = timeUntilExpiry < fiveMinutes && timeUntilExpiry > 0;
    
    if (shouldRefresh) {
      console.log('🔄 Token debe renovarse pronto:', {
        timeUntilExpiry: Math.round(timeUntilExpiry / 1000 / 60),
        expiresAt: expiresAt.toISOString()
      });
    }
    
    return shouldRefresh;
  }
  
  setUser(user: any): void {
    localStorage.setItem('user', JSON.stringify(user));
  }

  getUser(): any {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }
}